import {
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    Icon,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Tooltip,
} from '@mui/material';
import React from 'react';

import { If } from 'app/components';
import { MidTuple } from 'app/model';
import { MidFilter } from 'app/model/mid-filter';

interface TupleFilterInputProps {
    value: MidFilter;
    onChange?: (value: MidFilter) => void;
    onDelete?: () => void;
    fixed?: boolean;
}

export const TupleFilterInput: React.FC<TupleFilterInputProps> = ({ value, fixed, onChange, onDelete }) => {
    return (
        <>
            <Grid item xs={4} md={2}>
                <FormControl fullWidth variant='outlined' size='small'>
                    <InputLabel>Field</InputLabel>
                    <Select
                        disabled={fixed}
                        name='filterField'
                        label='Field'
                        value={value.field}
                        onChange={(event) => onChange?.({ ...value, field: event.target.value as keyof MidTuple })}
                    >
                        <MenuItem value='mtid'>mtid</MenuItem>
                        <MenuItem value='mid'>mid</MenuItem>
                        <MenuItem value='merchdesc'>merchdesc</MenuItem>
                        <MenuItem value='storeId'>storeId</MenuItem>
                        <MenuItem value='brandId'>brandId</MenuItem>
                        <MenuItem value='mcc'>mcc</MenuItem>
                        <MenuItem value='city'>city</MenuItem>
                        <MenuItem value='state'>state</MenuItem>
                        <MenuItem value='zip'>zip</MenuItem>
                        <MenuItem value='country'>country</MenuItem>
                        <MenuItem value='channel'>channel</MenuItem>
                        <MenuItem value='correctionPatId'>correction id</MenuItem>
                        <MenuItem value='storeNum'>store number</MenuItem>
                        <MenuItem value='storeNumPatId'>storenumber patternid</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={5} md={2} lg={3}>
                <TextField
                    fullWidth
                    name='filterValue'
                    type='text'
                    size='small'
                    label='Value'
                    variant='outlined'
                    value={value.value}
                    onChange={(event) => onChange?.({ ...value, value: event.target.value.toUpperCase() })}
                />
            </Grid>
            <Grid item xs={3} md={2} lg={1}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={value.negate}
                            name='filterNot'
                            onChange={(event) => onChange?.({ ...value, negate: event.target.checked })}
                        />
                    }
                    label='Not'
                />
                <If condition={!fixed}>
                    <Tooltip title='Remove Filter'>
                        <IconButton onClick={() => onDelete?.()} size='small' color='error'>
                            <Icon>delete</Icon>
                        </IconButton>
                    </Tooltip>
                </If>
            </Grid>
        </>
    );
};
